import React, { type JSX } from 'react';

import { useAppDispatch } from '@fiji/common';
import { setWeekModeFilters } from '@fiji/common/src/features/schedule/schedulerSlice';
import { useGetAllDeviceCategoriesMutation } from '@fiji/common/src/features/deviceManagement/ontologyApi';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export const DeviceTypeFilterDropDown = React.memo((): JSX.Element => {
    const dispatch = useAppDispatch();
    const [getAllDeviceCategories, { data }] = useGetAllDeviceCategoriesMutation();
    React.useEffect(() => {
        void getAllDeviceCategories({ category: 'CATEGORY' });
    }, []);
    return (
        <FormControl style={{ width: '18%' }} variant="filled">
            <InputLabel id={'select-Assign-to-action'} required={false}>
                Device Type
            </InputLabel>
            <Select
                displayEmpty
                onChange={(e: any) => {
                    dispatch(setWeekModeFilters({ key: 'category', value: e.target?.value }));
                }}
            >
                {data?.data?.length &&
                    data?.data?.map((item: any) => (
                        <MenuItem key={item?.id} value={item?.id}>
                            {item?.name}
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    );
});
